/* ==========================================================================
   Jane Lushka v1.2: product page, below the buy box (phase 3)

   pdp:14 Reviews.io carousel: the script and its two stylesheets load only when
          [data-jl-reviews-carousel] comes within 200px of the viewport (L10),
          then `new carouselInlineWidget(id, options)` runs once per box. The
          options come from the section (data-options). Auto scroll is off under
          prefers-reduced-motion (L11). A blocked script leaves the reserved box
          and no console error.
   pdp:15 "You may also like": when the rail has fewer cards than its target, the
          recommendations endpoint (this section, intent related) pads it after
          load; cards are deduped by handle and by model (data-group, one colour
          per model), and the current product and its colour siblings are
          skipped. An empty rail stays hidden.
   Loaded with defer by sections/main-product.liquid. Re-runs on
   shopify:section:load in the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  if (window.JLPdpBelow && window.JLPdpBelow.__v12) return;
  var api = window.JLPdpBelow = window.JLPdpBelow || {};
  api.__v12 = true;

  var reduceMotion = function () {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  /* ---------------- reviews carousel ---------------- */

  var scriptPromise = null;

  function addStylesheet(href) {
    if (!href) return;
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') === href) return;
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadWidgetScript(src) {
    if (typeof window.carouselInlineWidget === 'function') return Promise.resolve();
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      if (!src) { reject(new Error('no script')); return; }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.setAttribute('data-jl-reviews-script', '');
      s.onload = function () {
        if (typeof window.carouselInlineWidget === 'function') resolve();
        else reject(new Error('no widget'));
      };
      s.onerror = function () {
        scriptPromise = null;
        reject(new Error('blocked'));
      };
      document.head.appendChild(s);
    });
    return scriptPromise;
  }

  function startCarousel(box) {
    if (!box || box.__jlCarouselStarted) return;
    box.__jlCarouselStarted = true;

    var options;
    try {
      options = JSON.parse(box.getAttribute('data-options') || '{}');
    } catch (e) {
      return;
    }
    if (reduceMotion()) {
      options.options = options.options || {};
      options.options.general = options.options.general || {};
      options.options.general.enable_auto_scroll = false;
    }

    var mount = box.querySelector('[id]');
    if (!mount) return;

    (box.getAttribute('data-styles') || '').split(/\s+/).forEach(function (href) {
      if (href) addStylesheet(href);
    });

    loadWidgetScript(box.getAttribute('data-script')).then(function () {
      if (box.getAttribute('data-jl-carousel') === 'ready') return;
      try {
        /* eslint-disable-next-line no-new, new-cap */
        new window.carouselInlineWidget(mount.id, options);
        box.setAttribute('data-jl-carousel', 'ready');
      } catch (e) {
        box.setAttribute('data-jl-carousel', 'failed');
      }
    }, function () {
      box.setAttribute('data-jl-carousel', 'failed');
    });
  }

  function initReviews(scope) {
    var boxes = (scope || document).querySelectorAll('[data-jl-reviews-carousel]');
    if (!boxes.length) return;

    if (!('IntersectionObserver' in window)) {
      var startAll = function () {
        for (var i = 0; i < boxes.length; i++) startCarousel(boxes[i]);
      };
      if (document.readyState === 'complete') startAll();
      else window.addEventListener('load', startAll, { once: true });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        startCarousel(entry.target);
      });
    }, { rootMargin: '200px 0px' });

    for (var j = 0; j < boxes.length; j++) {
      if (!boxes[j].__jlCarouselStarted) io.observe(boxes[j]);
    }
  }

  /* ---------------- recommendations ---------------- */

  function whenIdle(fn) {
    var run = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2000 });
      else window.setTimeout(fn, 200);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function padRecos(root) {
    var list = root.querySelector('[data-jl-recos-list]');
    var url = root.getAttribute('data-url');
    if (!list || !url || !window.fetch || !window.DOMParser) return;

    var target = parseInt(root.getAttribute('data-target'), 10) || 4;
    var current = root.getAttribute('data-product-handle') || '';
    var group = (root.getAttribute('data-group') || '').toLowerCase();
    var cards = list.querySelectorAll('[data-jl-reco-card]');
    if (cards.length >= target) return;

    var seen = {};
    var seenGroup = {};
    for (var i = 0; i < cards.length; i++) {
      seen[cards[i].getAttribute('data-handle')] = true;
      var cardGroup = (cards[i].getAttribute('data-group') || '').toLowerCase();
      if (cardGroup) seenGroup[cardGroup] = true;
    }

    window.fetch(url, { credentials: 'same-origin' }).then(function (res) {
      return res.ok ? res.text() : '';
    }).then(function (html) {
      if (!html) return;
      var doc = new window.DOMParser().parseFromString(html, 'text/html');
      var found = doc.querySelectorAll('[data-jl-reco-card]');
      var count = list.querySelectorAll('[data-jl-reco-card]').length;
      for (var k = 0; k < found.length && count < target; k++) {
        var li = found[k];
        var handle = li.getAttribute('data-handle');
        var liGroup = (li.getAttribute('data-group') || '').toLowerCase();
        if (!handle || seen[handle] || handle === current) continue;
        if (group && liGroup === group) continue;
        if (liGroup && seenGroup[liGroup]) continue;
        seen[handle] = true;
        if (liGroup) seenGroup[liGroup] = true;
        list.appendChild(document.importNode(li, true));
        count++;
      }
      if (count > 0) root.hidden = false;
    }).catch(function () {
      /* the rail keeps what the server rendered */
    });
  }

  function initRecos(scope) {
    var roots = (scope || document).querySelectorAll('[data-jl-recos]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.__jlRecos) continue;
      root.__jlRecos = true;
      whenIdle(padRecos.bind(null, root));
    }
  }

  /* ---------------- init ---------------- */

  function init(scope) {
    initReviews(scope);
    initRecos(scope);
  }

  api.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
